__turbopack_context__.v({
  "artIn": "seasonal-module__P_5W_G__artIn",
  "beam": "seasonal-module__P_5W_G__beam",
  "beamBase": "seasonal-module__P_5W_G__beamBase",
  "beamIn": "seasonal-module__P_5W_G__beamIn",
  "beamSheen": "seasonal-module__P_5W_G__beamSheen",
  "beamSheen2": "seasonal-module__P_5W_G__beamSheen2",
  "beamSway": "seasonal-module__P_5W_G__beamSway",
  "beamSweep": "seasonal-module__P_5W_G__beamSweep",
  "digitIn": "seasonal-module__P_5W_G__digitIn",
  "fog": "seasonal-module__P_5W_G__fog",
  "fogB": "seasonal-module__P_5W_G__fogB",
  "fogMoveA": "seasonal-module__P_5W_G__fogMoveA",
  "fogMoveB": "seasonal-module__P_5W_G__fogMoveB",
  "inheritFont": "seasonal-module__P_5W_G__inheritFont",
  "layerIn": "seasonal-module__P_5W_G__layerIn",
  "pumpkinIn": "seasonal-module__P_5W_G__pumpkinIn",
});
